import React, { Component } from "react";
import {
	EmailShareButton,
	FacebookShareButton,
	HatenaShareButton,
	InstapaperShareButton,
	LineShareButton,
	LinkedinShareButton,
	LivejournalShareButton,
	MailruShareButton,
	OKShareButton,
	PinterestShareButton,
	PocketShareButton,
	RedditShareButton,
	TelegramShareButton,
	TumblrShareButton,
	TwitterShareButton,
	ViberShareButton,
	VKShareButton,
	WhatsappShareButton,
	WorkplaceShareButton,
	EmailIcon,
	FacebookIcon,
	FacebookMessengerIcon,
	HatenaIcon,
	InstapaperIcon,
	LineIcon,
	LinkedinIcon,
	LivejournalIcon,
	MailruIcon,
	OKIcon,
	PinterestIcon,
	PocketIcon,
	RedditIcon,
	TelegramIcon,
	TumblrIcon,
	TwitterIcon,
	ViberIcon,
	VKIcon,
	WeiboIcon,
	WhatsappIcon,
	WorkplaceIcon
} from "react-share";

export default class Share extends Component {
	
	constructor(){
		super()
		this.state = {
			open:false,
		}
		this.toggleShare = this.toggleShare.bind(this);
	}
	
	toggleShare() {  
		if (this.state.open === true) {
			this.setState({open : false});
		} else {
			this.setState({open : true});
		}
    }
    
	render () {
		
		let url = window.location + '';
		let thisClass = 'c-share-buttons__wrapper';
		if (this.state.open === true) {
			thisClass = 'c-share-buttons__wrapper state-open';
		}
		
		return (
			<>
				<div target="_blank" className="c-share-buttons__button"><div className="c-share-buttons__button__icon" onClick={this.toggleShare} dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 24 24"><path style="fill:#363636;" d="M7.96,5.36l2.48-2.47l0.01-0.01c0.14-0.17,0.3-0.3,0.48-0.41c0,0.03-0.02,0.06-0.02,0.09l-0.02,13.89 c0.04,0.61,0.57,1.06,1.18,1.02c0.54-0.04,0.98-0.47,1.02-1.02l0.02-13.88c0-0.01,0-0.02,0-0.02c0.03,0.02,0.06,0.04,0.09,0.06 c0.11,0.09,0.2,0.19,0.29,0.29l2.48,2.47c0.39,0.47,1.08,0.53,1.55,0.13c0.47-0.39,0.53-1.08,0.13-1.55 c-0.04-0.05-0.09-0.1-0.14-0.14l-2.48-2.47c-0.82-0.82-1.93-1.28-3.08-1.29v0c-1.15,0-2.26,0.46-3.06,1.29L6.42,3.81 c-0.4,0.46-0.35,1.15,0.1,1.55C6.93,5.72,7.55,5.72,7.96,5.36z M22.11,9.65h-3.94c-0.6-0.06-1.14,0.39-1.2,0.99 c-0.06,0.6,0.39,1.14,0.99,1.2c0.07,0.01,0.14,0.01,0.21,0h2.85v9.21c0.03,0.17-0.03,0.35-0.15,0.48c-0.27,0.19-0.6,0.27-0.93,0.23 H4.05c-0.33,0.04-0.66-0.04-0.93-0.23c-0.09-0.09-0.15-0.2-0.15-0.48v-9.21h2.85c0.6,0.06,1.14-0.39,1.2-0.99 c0.06-0.6-0.39-1.14-0.99-1.2c-0.07-0.01-0.14-0.01-0.21,0H1.88l0,0c-0.6,0-1.09,0.49-1.09,1.09v10.3 c-0.02,0.78,0.29,1.53,0.84,2.07c0.67,0.58,1.54,0.87,2.43,0.82h15.89c0.88,0.05,1.75-0.25,2.43-0.82c0.55-0.55,0.85-1.3,0.84-2.07 v-10.3C23.21,10.14,22.72,9.65,22.11,9.65z"/></svg>'}}></div>
					<div className={thisClass}>
						<FacebookShareButton url={url}>
							<FacebookIcon size={32} round={true} />
						</FacebookShareButton>
						<TwitterShareButton url={url}>
							<TwitterIcon size={32} round={true} />
						</TwitterShareButton>
						<WhatsappShareButton url={url}>
							<WhatsappIcon size={32} round={true} />
						</WhatsappShareButton>
						<EmailShareButton url={url}>
							<EmailIcon size={32} round={true} />
						</EmailShareButton>
					</div>
				</div>
				
			</>
		)
			
	}
}
